/**
 * DataTables Excel export formatter
 *
 * @param {Object} columnConfig
 * Example:
 * {
 *   2: { type: 'image', label: 'View Image' },
 *   11: { type: 'map', label: 'Open Map' }
 * }
 */
export function excelExportFormatter(columnConfig = {}) {
  return {
    body: function (data, row, column, node) {

      const config = columnConfig[column];

      // If column not configured → return text
      if (!config) {
        return $(node).text().trim();
      }

      // IMAGE COLUMN
      if (config.type === 'image') {
        const img = $('img', node);
        const url = img.length ? img.attr('src') : '';
        return url;
      }

      // MAP / LOCATION LINK
      if (config.type === 'map') {
        const link = $('a', node);
        const url = link.length ? link.attr('href') : '';
        return url;
      }

      // DIRECT LINK COLUMN
      if (config.type === 'link') {
        const url = $(node).text().trim();
        return url;
      }

      // DEFAULT FALLBACK
      return $(node).text().trim();
    }
  };
}
